import React from 'react'

const CalendarIcon = ({ color = 'none', width = '24', height = '25' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill={color}>
      <g mask="url(#mask0_1298_7073)">
        <path
          d="M14.5 18.5C13.8 18.5 13.2083 18.2583 12.725 17.775C12.2417 17.2917 12 16.7 12 16C12 15.3 12.2417 14.7083 12.725 14.225C13.2083 13.7417 13.8 13.5 14.5 13.5C15.2 13.5 15.7917 13.7417 16.275 14.225C16.7583 14.7083 17 15.3 17 16C17 16.7 16.7583 17.2917 16.275 17.775C15.7917 18.2583 15.2 18.5 14.5 18.5ZM5 22.5C4.45 22.5 3.979 22.3043 3.587 21.913C3.19567 21.521 3 21.05 3 20.5V6.5C3 5.95 3.19567 5.47933 3.587 5.088C3.979 4.696 4.45 4.5 5 4.5H6V2.5H8V4.5H16V2.5H18V4.5H19C19.55 4.5 20.021 4.696 20.413 5.088C20.8043 5.47933 21 5.95 21 6.5V20.5C21 21.05 20.8043 21.521 20.413 21.913C20.021 22.3043 19.55 22.5 19 22.5H5ZM5 20.5H19V10.5H5V20.5ZM5 8.5H19V6.5H5V8.5Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default CalendarIcon
